module.exports = __webpack_public_path__ + "static/img/PuzzleMaster.43e5f76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui/reports/PuzzleMaster.png
// module id = qvNx
// module chunks = 1